import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconTwitter = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="12" fill={theme.colors.text.primary} />
      <path
        d="M15.4505 6.57642H17.2905L13.2705 11.1714L18 17.4229H14.297L11.397 13.6309L8.078 17.4229H6.237L10.537 12.5079L6 6.57692H9.797L12.4185 10.0429L15.4505 6.57642ZM14.805 16.3219H15.8245L9.243 7.61992H8.149L14.805 16.3219Z"
        fill={theme.colors.background.primary}
      />
    </IconBase>
  )
}
